import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { combineLatest, Observable, take } from 'rxjs';
import { loadStoreState, setInitialStoreState } from '../../../../../../../common/utils';
import { CompartmentRuleListFacade } from './compartment-rule-list.facade';
import { ListSearchCriteriaFacade, ListSearchCriteriaType } from '../../../../../list-search-criteria';
import { CompartmentItemFacade } from '../../compartment-item.facade';

import { LocalStorageService } from '../../../../../../services/local-storage.service';
import { LocalStorageKey } from '../../../../../../../common';

@Injectable({
  providedIn: 'root',
})
export class CompartmentRuleListGuard {
  constructor(
    private compartmentRuleListFacade: CompartmentRuleListFacade,
    private listSearchCriteriaFacade: ListSearchCriteriaFacade,
    private compartmentItemFacade: CompartmentItemFacade,
    private localStorageService: LocalStorageService,
  ) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    combineLatest([
      this.compartmentItemFacade.compartmentId$,
      this.localStorageService.getData$(LocalStorageKey.CompartmentId),
    ])
      .pipe(take(1))
      .subscribe(([id, localId]: [number, string]) => {
        if (id && id.toString() !== localId) {
          this.listSearchCriteriaFacade.setInitialStateByType(ListSearchCriteriaType.CompartmentRules);
        }
        this.localStorageService.setData$({ [LocalStorageKey.CompartmentId]: id.toString() });
      });

    return loadStoreState(this.compartmentRuleListFacade);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.compartmentRuleListFacade);
  }
}
